<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-4xl">
    <p class="mb-6">
      @if (competition(); as c) {
        <a
          [routerLink]="['/competitions', c.id]"
          class="text-sm text-dusk hover:text-parchment hover:underline"
          >&larr; Back to {{ c.name }}</a
        >
      }
    </p>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else {
      <span class="mb-2 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
        >Standings</span
      >
      <h1 class="mb-6 font-display text-3xl font-semibold text-parchment">
        {{ competition()?.name }} Leaderboard
      </h1>

      @if (rows().length === 0) {
        <p class="rounded-md border border-hairline bg-panel p-6 text-sm text-dusk">
          No scores yet.
        </p>
      } @else {
        <p class="mb-3 text-xs text-dusk">Click a contestant to see where their points came from.</p>
        <div class="overflow-x-auto rounded-md border border-hairline bg-panel">
          <table class="w-full text-left text-sm">
            <thead>
              <tr class="border-b border-hairline text-xs uppercase tracking-wide text-dusk">
                <th class="px-4 py-3 font-semibold">Rank</th>
                <th class="px-4 py-3 font-semibold">Contestant</th>
                <th class="px-4 py-3 font-semibold">Points</th>
              </tr>
            </thead>
            <tbody>
              @for (entry of rows(); track entry.contestantId; let i = $index) {
                <tr
                  class="cursor-pointer border-b border-hairline last:border-0 hover:bg-hairline/10"
                  (click)="toggle(entry.contestantId)"
                >
                  <td class="px-4 py-3 text-dusk">{{ i + 1 }}</td>
                  <td class="px-4 py-3 text-parchment">
                    <span class="mr-1 inline-block w-3 text-dusk">{{
                      expandedIds().has(entry.contestantId) ? '⌄' : '›'
                    }}</span>
                    {{ entry.displayName }}
                  </td>
                  <td class="px-4 py-3 font-semibold text-gold">{{ entry.totalPoints }}</td>
                </tr>
                @if (expandedIds().has(entry.contestantId)) {
                  <tr class="border-b border-hairline bg-hairline/5 last:border-0">
                    <td colspan="3" class="px-4 py-4">
                      @if (entry.pickBreakdown.length === 0 && entry.otherAwards.length === 0) {
                        <p class="text-sm text-dusk">No scoring awards yet.</p>
                      } @else {
                        @if (entry.pickBreakdown.length > 0) {
                          <table class="w-full text-left text-sm">
                            <thead>
                              <tr class="text-xs uppercase tracking-wide text-dusk">
                                <th class="px-2 py-1 font-semibold">Pick</th>
                                <th class="px-2 py-1 font-semibold">Date of death</th>
                                <th class="px-2 py-1 font-semibold">Cause</th>
                                <th class="px-2 py-1 font-semibold">Points</th>
                                <th class="px-2 py-1 font-semibold">Bonus</th>
                                <th class="px-2 py-1 font-semibold">Notes</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (row of entry.pickBreakdown; track row.pickId) {
                                <tr>
                                  <td class="px-2 py-1 text-parchment">{{ row.personName }}</td>
                                  <td class="px-2 py-1 text-dusk">
                                    {{ row.dateOfDeath ? dateOnly(row.dateOfDeath) : '—' }}
                                  </td>
                                  <td class="px-2 py-1 text-dusk">{{ row.causeOfDeath ?? '—' }}</td>
                                  <td class="px-2 py-1 text-parchment">{{ row.points || '—' }}</td>
                                  <td class="px-2 py-1 text-parchment">
                                    {{
                                      row.prizeDescriptions.length > 0
                                        ? row.prizeDescriptions.join(', ')
                                        : '—'
                                    }}
                                  </td>
                                  <td class="px-2 py-1 text-dusk">
                                    @for (award of row.awards; track award.awardId) {
                                      <div>{{ award.name }} ({{ awardValue(award) }})</div>
                                    }
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        }
                        @if (entry.otherAwards.length > 0) {
                          <p class="mt-3 text-sm text-dusk">
                            Other awards:
                            @for (award of entry.otherAwards; track award.awardId) {
                              <span class="mr-2 text-parchment"
                                >{{ award.name }} ({{ awardValue(award) }})</span
                              >
                            }
                          </p>
                        }
                      }
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
</section>
